import styled from 'styled-components'

export const Columns = styled.div.attrs((props) => ({
  className: `columns ${props.className}`,
}))``

export const Column = styled.div.attrs((props) => ({
  className: `column ${props.className}`,
}))``
